import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} preto. Anotado.",
  "alert.toast.escalation": "{hazard} preto. Agora peor.",
  "alert.toast.inPath": "{hazard} cara a ti. Claro.",
  "alert.toast.allClear": "Ben de novo preto de {place}.",
  "alert.toast.tap": "Detalles, se tes curiosidade.",
  "alert.takeover.title": "{hazard}. É o momento de moverse.",
  "alert.takeover.details": "Os detalles",
  "alert.takeover.dismiss": "Anotado",
  "now.status.allClear": "Nada que informar.",
  "now.status.stayAware": "Ollos abertos.",
  "now.status.sub.allClear": "Nada dentro do teu radio. Gozo efémero.",
  "now.activity.empty": "Ninguén informou de nada. Sospeitoso.",
  "onboarding.promise.tagline": "Veciños avisando veciños. Revolucionario.",
  "onboarding.promise.continue": "Ben, imos",
  "onboarding.home.browse": "Só mirando",
  "you.voice.intro": "Escolle ata onde queres que isto sexa directo.",
};
